export default "__VITE_ASSET__DoxNMZFn__"